import { Box } from '@factorialco/deprecated-design-system'
import { Text } from '@factorialco/deprecated-design-system'

interface TitleHeaderProps {
  titleLabel: string
  subtitleLabel: string
}
const TitleHeader = ({ titleLabel, subtitleLabel }: TitleHeaderProps) => {
  return (
    <Box flexDirection="column" gap="s8" paddingBottom="s16">
      <Text size="300" weight="semibold" color="grey1000">
        {titleLabel}
      </Text>
      <Text size="200" weight="normal">
        {subtitleLabel}
      </Text>
    </Box>
  )
}

export default TitleHeader
